/* global $ */
import * as _ from 'lodash';

export default {
  data() {
    return {
      sliderUpdatePending: false,
      slickOptions: {
        dots: true,
        infinite: true,
        fade: true,
        arrows: true,
        speed: 300,
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        autoplay: false,
        customPaging: function () {
          return '<button type="button" class="slick-slider-button"></button>';
        },
      }
    };
  },
  created() {
    // console.log('hasSlickSlider created()');
  },
  mounted() {
    // console.log('hasSlickSlider mounted()');
    this.$nextTick(() => {
      // console.log('hasSlickSlider mounted() $nextTick()', this.uuid);
      this.initSlickSlider(this.uuid);
    });
  },
  beforeUpdate() {
    // console.log('hasSlickSlider beforeUpdate()');
  },
  updated() {
    // console.log('hasSlickSlider updated()');
    this.$nextTick(() => {
      if (this.sliderUpdatePending) {
        // Turn it off and back on again
        this.destroySlickSlider(this.uuid);
        this.initSlickSlider(this.uuid);
        this.sliderUpdatePending = false;
      }
    });
  },
  beforeDestroy() {
    // console.log('hasSlickSlider beforeDestroy()');
    this.destroySlickSlider(this.uuid);
  },
  destroyed() {
    // console.log('hasSlickSlider destroyed()');
  },
  methods: {
    destroySlickSlider(id) {
      // console.log('hasSlickSlider destroySlickSlider()', id);
      const sliders = $('#' + id).find(this.sliderClass);

      sliders.each((i, slider) => {
        // Slick Selector.
        const slickSlider = $('#' + $(slider).attr('id'));
        const slickDiv = slickSlider[0];

        // Check if it's already been initialized
        if (slickDiv.classList.contains('slick-initialized')) {
          slickSlider.slick('unslick');
        }

      });
    },
    initSlickSlider: _.throttle(function (id) {
      // console.log('hasSlickSlider initSlickSlider()', id);
      const container = $('#' + id);
      const sliders = container.find(this.sliderClass);
      const { slickOptions } = this;

      // console.log('hasSlickSlider initSlickSlider() :sliders', sliders);

      slickOptions.prevArrow = container.find('.arrow-prev');
      slickOptions.nextArrow = container.find('.arrow-next');

      sliders.each((i, slider) => {
        // console.log('hasSlickSlider initSlickSlider() :slider', $(slider).attr('id'));
        // Slick Selector.
        const slickSlider = $('#' + $(slider).attr('id'));

        slickSlider.on('init', function () {
          // Remove loading
          $(this).parent().removeClass('slick-loading');

          // Move around the slick dots
          $(this).find('ul.slick-dots')
            .wrap("<div class='slick-dots-container'></div>");
          $(this).find('ul.slick-dots li').each(function (index) {
            $(this).addClass('dot-index-' + index);
          });
          $(this).find('ul.slick-dots').css('transform', 'translateX(0)');

          $(this).find('ul.slick-dots li').eq(4).addClass('n-small-1');

        }).slick(slickOptions);

      });
    }, 1000),
    resizeSlickSlider(id) {
      // console.log('hasSlickSlider resizeSlickSlider()', id);
      const container = $('#' + id);
      const sliders = container.find(this.sliderClass);

      sliders.each((i, div) => {
        // Slick Selector.
        const slickSlider = $('#' + $(div).attr('id'));
        // console.log('hasSlickSlider resizeSlickSlider() :slickSlider', slickSlider);

        slickSlider.slick('setDimensions');
        slickSlider.slick('slickGoTo', 0);
      });
    },
  }
};
